<template>
  <li class="cursor-pointer hover:bg-gray-100 rounded p-2" @click="$router.push(`/projekt/${projectId}`)">
    <RoseChartD3
      v-if="showChart"
      :chartId="`panelchart-${projectId}`"
      :compassId="projectId"
      :frameworkId="currentFramework.frameworkId"
      :categories="categories"
      :datasets="this.datasets"
      :options="{
        canSelectCategory: false,
        canSaveRatings: false,
        clickable: false,
        highlightSelectedCategory: false,
        canHover: false,
        canRate: false,
        allowCategoryClick: false,
        maxValue: currentFramework.maxValue,
        steps: currentFramework.steps,
        viewMode: currentFramework.viewMode,
        markerLineColor: 'rgba(253, 0, 116, 0)',
      }"
    />
    <div class="relative">
      <h2 class="text-2xl mt-2 text-center">
        {{ projectTitle !== '' ? projectTitle : 'NO NAME' }}
      </h2>
      <div v-if="user && project.userId !== user.id" class="bg-white text-sm text-gray-500 text-center p-1 border-2 text-uppercase w-fit absolute right-0 -top-10">
        {{ $t('Projects.Project list view.SharedWithMe') }}
      </div>
    </div>
  </li>
</template>

<script>
import RoseChartD3 from '@/components/shared/RoseChartD3'

export default {
  components: {
    RoseChartD3,
  },
  props: {
    projectId: {
      type: Number,
      required: true,
    },
    projectTitle: {
      type: String,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
    chartData: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      showChart: false,
      isVisible: false,
      currentFramework: null,
      categories: [],
      datasets: [],
      observer: null,
    }
  },
  computed: {
    user () {
      return this.$store.getters['auth/user']
    },
  },
  watch: {
    // Watch for chart data to be loaded asynchronously
    chartData: {
      immediate: true,
      handler (newChartData) {
        if (newChartData && this.isVisible) {
          this.currentFramework = newChartData.framework
          this.categories = newChartData.categories || []
          this.datasets = newChartData.datasets || []
          this.showChart = true
        }
      },
    },
  },
  mounted () {
    // Use IntersectionObserver to only render charts when they become visible
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.isVisible) {
            this.isVisible = true
            // Chart data is now provided via props from parent
            // No individual API calls needed - all data is preloaded
            if (this.chartData) {
              this.currentFramework = this.chartData.framework
              this.categories = this.chartData.categories || []
              this.datasets = this.chartData.datasets || []
              this.showChart = true
            }
            // Stop observing once visible
            this.observer.unobserve(entry.target)
          }
        })
      },
      {
        rootMargin: '100px', // Start loading 100px before the item comes into view
        threshold: 0.01,
      },
    )

    // Observe the component's root element
    this.observer.observe(this.$el)
  },
  beforeUnmount () {
    // Clean up observer
    if (this.observer) {
      this.observer.disconnect()
    }
  },
}
</script>

<style scoped>
  .w-fit {
    width: fit-content;
  }
</style>
